var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 44C20 46.2091 21.7909 48 24 48C26.2091 48 28 46.2091 28 44V28H44C46.2091 28 48 26.2091 48 24C48 21.7909 46.2091 20 44 20H28V4C28 1.79086 26.2091 0 24 0C21.7909 0 20 1.79086 20 4V20H4C1.79086 20 0 21.7909 0 24C0 26.2091 1.79086 28 4 28H20V44Z"
  })));
};
export default SvgPlus;